import GenericDataService from "../../services/GenericDataService";
import {loadLanguageAsync} from '@/i18n'
import { Preferences } from '@capacitor/preferences';


const state = () => ({
    apiUrl : "",
    idToken:"",
    accessToken:"",
    user: {}, // currentUser OU loggedAs
    currentUser: {}, // Toujours le user principal
    loggedAs: null, // Toujour le user en tant que
    currentAccountId: 0,
    avatarKey: 0,
    currentAccountId: 0,
    loader: false
});
 
const getters = {};
 
const actions = {
    async GET_CURRENT_USER({commit}) {
        await GenericDataService.getData("myprofile/get").then(async (response) => {
            console.log('account_domain : ', ('m.' + response.data.data.accountParameters.domain), ' |||| window_location :', window.location.host, ' |||| account_id : ', response.data.data.accountParameters.id, ' |||| account_name : ', response.data.data.accountParameters.name);

            if(process.env.NODE_ENV !== 'development' && response.data.data.accountParameters.domain) {
                if(('m.' + response.data.data.accountParameters.domain) !== window.location.host) {
                    let url = window.location.protocol + '//' + ('m.' + response.data.data.accountParameters.domain) + window.location.pathname + "?account_id=" + response.data.data.accountParameters.id;
                    window.location.replace(url)
                }
            }

            const { value } = await Preferences.get({ key: 'account_id' });
            if(value && value != 0) {
                commit("setCurrentAccountId", value) 
            }
    
            commit("setCurrentUser", response);
        })
    },
    SET_API_URL({commit}, value) {
        commit("setApiUrl", value)
    },
    SET_AUTH({commit}, payload){
        commit('setAuth', payload)
    },
    SET_CURRENT_ACCOUNT_ID({ commit }, value){
        commit("setCurrentAccountId", value)
    },
    SET_LOADER({commit}, value){
        commit("setLoader", value)
    }
};
 
const mutations = {
    setApiUrl(state, value) {
        state.apiUrl = value
    },
    setCurrentAccountId(state, accountId){
        state.currentAccountId = accountId
    },
    async setAuth(state, payload){
        state.idToken = payload.idToken
        state.accessToken = payload.accessToken

        const { value } = await Preferences.get({ key: 'account_id' });
        if(value && value != 0) {
            state.currentAccountId = value
        }
    },
    async setCurrentUser(state, currentUser){
        state.currentUser = currentUser.data.data
        
        if(state.currentAccountId == 0 || !state.currentAccountId)
            state.currentAccountId = ""+currentUser.data.data.accountParameters.id

        // Start - Update account_id cookie
        await Preferences.set({
            key: 'account_id',
            value: state.currentAccountId,
        });
        // End - Update account_id cookie
        
        document.title = state.currentUser.accountParameters.name
        state.loggedAs = currentUser.data.data.loggedAs
        state.user = currentUser.data.data.loggedAs ? state.loggedAs : state.currentUser.profile;
        if(currentUser.data.data.parameters.lang){
           loadLanguageAsync(currentUser.data.data.parameters.lang)
        }
    },
    setLoader(state, value){
        state.loader = value
    }
};
 
export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}